const AUTH_EVENTS = {
  loginConfirmed: 'event:auth-loginConfirmed',
  loginCancelled: 'event:auth-loginCancelled',
  logoutConfirmed: 'event:auth-logoutConfirmed',
  loginRequired: 'event:auth-loginRequired',
  forbidden: 'event:auth-forbidden',
};

export default AUTH_EVENTS;



// WEBPACK FOOTER //
// ./client/components/auth/auth.constant.js